import type { Currency } from "@mainsail/schema";
import type { DeepReadonly } from "../../util/type";
import { bound } from "ecce-react";


export class CurrencyService {

	#currencies: Record<string, Currency>;

	constructor(currencies: DeepReadonly<Currency>[]) {
		this.#currencies = Object.fromEntries(currencies.map(currency =>
			[ currency.id, currency ]
		));
	}

	get(currencyCode: string): Currency {
		const currency = this.#currencies[currencyCode];
		if(!currency) {
			throw new Error("No currency found with code: " + currencyCode);
		}

		return currency;
	}

	roundConvertedCurrency(amount: number): number {
		return Number.parseFloat(amount.toPrecision(3));
	}

	@bound()
	fromUsd(currencyCode: string, amount: number): number {
		const currency = this.get(currencyCode);
		const converted = amount * currency.convertFromUSD;
		const rounded = this.roundConvertedCurrency(converted);
		return rounded;
	}

	@bound()
	toUsd(currencyCode: string, amount: number): number {
		const currency = this.get(currencyCode);
		const converted = amount / currency.convertFromUSD;
		const rounded = this.roundConvertedCurrency(converted);
		return rounded;
	}

	@bound()
	convert(args: { from: string; to: string; amount: number; }): number {
		if(args.from === args.to) {
			return args.amount;
		}

		const from = this.get(args.from);
		const to = this.get(args.to);

		const usd = args.amount / from.convertFromUSD;
		const converted = usd * to.convertFromUSD;
		const rounded = this.roundConvertedCurrency(converted);

		return rounded;
	}
}